import React, { useEffect, useState } from 'react';

import { List } from 'views/Dashboard/components';
import { NewsletterCarousel } from 'views/Newsletter/components';
import { Typography, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import { ViewList, PostAdd } from '@material-ui/icons';
import useWindowDimensions from 'customHooks/DimensionHook';
import { useHistory } from 'react-router-dom';
import { NewsletterData } from 'services/dataService';
import { consumeNewsletterRedirect } from 'helpers/newsletter';

export default () => {
  const classes = useStyles();
  const { t } = useTranslation(['label', 'button', 'newsletter']);
  const { width } = useWindowDimensions();
  const history = useHistory();
  const [newsletters, setNewsletters] = useState([]);
  const [canManageNewsletter, setCanManageNewsletter] = useState(false);

  const handleClick = () => {
    history.push(`/all-courses`);
  };

  useEffect(() => {
    const redirect = consumeNewsletterRedirect();
    if (redirect) {
      history.replace(redirect);
      return;
    }

    NewsletterData.getNewsletters()
      .then(({ data }) => {
        setNewsletters(data.newsletters);
        setCanManageNewsletter(data.canManage);
      })
      .catch(() => {});
  }, []);

  const hasNewsletters = newsletters.length > 0;

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography className={classes.sectionTitle} variant="h4">
          {hasNewsletters
            ? t('newsletter:section_title')
            : t('label:commons.news_releases')}
        </Typography>
        <div className={classes.headerActions}>
          {canManageNewsletter && (
            <Button
              color="primary"
              fullWidth={width < 750}
              variant="contained"
              onClick={() => history.push('/newsletter/create')}
            >
              <PostAdd style={{ marginRight: '5px' }} />
              {t('newsletter:btn_new')}
            </Button>
          )}
          <Button
            color="primary"
            fullWidth={width < 750}
            variant="outlined"
            onClick={handleClick}
          >
            <ViewList style={{ marginRight: '5px' }} />
            {t('button:commons.btn_new_courses')}
          </Button>
        </div>
      </div>

      {hasNewsletters && (
        <>
          <NewsletterCarousel newsletters={newsletters} />
          <Typography className={classes.sectionTitle} variant="h4">
            {t('label:commons.news_releases')}
          </Typography>
        </>
      )}

      <div className={classes.content}>
        <List />
      </div>
    </div>
  );
};
